import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import { Autologin as AutologinComponent } from "../components/Autologin/Autologin";

export const Autologin = () => {
  const centerSpinner = {
    display: "flex",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <Fragment>
      <Row>
        <Col style={centerSpinner}>
          <AutologinComponent />
        </Col>
      </Row>
    </Fragment>
  );
};
